
import * as R from 'ramda';
// constants
import * as GC from '../constants';
// helpers
// import { toNumber } from './calc';
import { fromEmptyStringToNull, fromNullToEmptyString } from './string';
import { isTrue, isObject, notContain, isNilOrEmpty, isNotNilAndNotEmpty } from './helpers';
//////////////////////////////////////////////////

const reorderList = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);

  result.splice(endIndex, 0, removed);

  return result;
};

// Not used
// const filterWithKeys = (pred, obj) => R.pipe(
//   R.toPairs,
//   R.filter(R.apply(pred)),
//   R.fromPairs,
// )(obj);

const renameKeys = R.curry((keysMap, obj) => R.reduce(
  (acc, key) => R.assoc(R.or(keysMap[key], key), obj[key], acc),
  {},
  R.keys(obj),
));

// Not used
// const toNumberObjectValues = (obj) => R.reduce(
//   (acc, key) => R.assoc(key, toNumber(obj[key]), acc),
//   {},
//   R.keys(obj),
// );

// Not used
// const indexToValue = R.curry((valueName, obj) => {
//   const copy = Object.assign({}, obj);
//   const values = Object.values(copy);
//   const keys = Object.keys(copy);
//   const newObject = Object.assign({}, values[0]);

//   newObject[valueName] = keys[0];

//   return newObject;
// });

const checkPropNotEqualInObjects = (propName, obj1, obj2) => R.not(R.eqProps(
  propName,
  obj1,
  obj2,
));

const pickObjectSystemFields = (item = {}) => R.pick(GC.GROUPED_FIELDS.SYSTEM_OMIT_ARR, item);

const pickNotNilAndNotEmptyPropsFromObject = (fields, object) => R.compose(
  R.pickBy(isNotNilAndNotEmpty),
  R.pick(fields),
)(object);

const omitObjectSystemFields = (item) => R.omit(GC.GROUPED_FIELDS.SYSTEM_OMIT_ARR, item);

const omitObjectChildArrayItemSystemFields = (arrayName, object) => {
  if (isNilOrEmpty(object)) return object;

  if (isNilOrEmpty(arrayName)) return object;

  const newArray = R.compose(
    R.map(R.omit(GC.GROUPED_FIELDS.SYSTEM_OMIT_ARR)),
    R.pathOr([], [arrayName]),
  )(object);

  return R.assoc(arrayName, newArray, object);
};

const omitObjectChildArrayItemSystemFieldsCurried = R.curry(omitObjectChildArrayItemSystemFields);

const createLabelValueOptionObject = (label = null, value = null) => ({ label, value });

const setStringValueInsteadObjectValueByPath = (obj, path, prop) => {
  if (isObject(R.path(path, obj))) {
    return R.assocPath(path, R.path([...path, prop], obj), obj);
  }

  return obj;
};

const filterAndJoinObjectFields = (obj, fields = [], joiner = ', ') => R.compose(
  R.join(joiner),
  R.filter(isNotNilAndNotEmpty),
  R.values,
  R.pick(fields),
)(obj);

const mapWithRenameKeys = R.curry((keysMap, items = []) => R.map(
  renameKeys(keysMap),
  items,
));

const mapObjectEmptyStringFieldsToNull = R.mapObjIndexed(
  (value) => fromEmptyStringToNull(value),
);

const mapObjectNullFieldsToEmptyStrings = R.mapObjIndexed(
  (value) => fromNullToEmptyString(value),
);

const mapNameGuidObjectPropsToLabelValueObject = R.map(
  ({ name, guid }) => ({ label: name, value: guid }),
);

const mapUnitIdGuidObjectPropsToLabelValueObject = R.map(
  ({ guid, unitId }) => ({ value: guid, label: unitId }),
);

const mapDisplayNameGuidObjectPropsToLabelValueObject = R.map(
  ({ guid, displayName }) => ({ value: guid, label: displayName }),
);

const mapNameGuidToLabelValue = (items) => {
  const keysMap = { name: 'label', guid: 'value' };

  return mapWithRenameKeys(keysMap, items);
};

const mapDisplayedValueDropdownOptionGuidToLabelValue = (items) => {
  const keysMap = { displayedValue: 'label', dropdownOptionGuid: 'value' };

  return mapWithRenameKeys(keysMap, items);
};

// Not used
// const mapOptionsValueToGuids = R.map(
//   ({ value }) => value,
// );

const mapObjectChildArrayItemEmptyStringFieldsToNull = (arrayName, object) => {
  if (isNilOrEmpty(object)) return object;

  if (isNilOrEmpty(arrayName)) return object;

  const newArray = R.compose(
    R.map(fromEmptyStringToNull),
    R.pathOr([], [arrayName]),
  )(object);

  return R.assoc(arrayName, newArray, object);
};

const notInList = (list, value) => (
  R.isNil(list) || notContain(value, list)
);

const sortListByDate = (list = [], propName, descOrder) => {
  if (isTrue(descOrder)) {
    return list.sort((a, b) => new Date(b[propName]) - new Date(a[propName]));
  }

  return list.sort((a, b) => new Date(a[propName]) - new Date(b[propName]));
};

const setPropsWithValuesToArrayItems = (arr, props) => (
  R.map((item) => R.mergeRight(
    item,
    R.mergeAll(R.map((prop) => ({[prop.name]: prop.value}), props)),
  ), arr)
);

const getArrayFilteredFromArrayByProp = (arr1, arr2, prop) => {
  const checkProp = (a, b) => R.eqProps(prop, a, b);

  return R.differenceWith(checkProp, arr1, arr2);
};

const prependEmptyLabelValueOption = (list = []) => R.prepend(GC.EMPTY_OPTION_OBJECT, list);

const transformArrayOfObjectsToStringByPropName = (arr = [], joiner, propName) => R.compose(
  R.join(joiner),
  R.filter(isNotNilAndNotEmpty),
  R.pluck(propName),
)(arr);

const mapArrayObjectEmptyStringFieldsToNull = (array) => {
  if (isNilOrEmpty(array)) return [];

  return R.map(mapObjectEmptyStringFieldsToNull, array);
};

const mapArrayOfObjectsToPropArray = (propName = '', items = []) => (
  R.map((item) => R.prop(propName, item), items)
);

const mapOmitObjectSystemFields = R.map(omitObjectSystemFields);

const incObjectVersion = (obj) => {
  if (isNilOrEmpty(obj)) return obj;

  const { version } = obj;

  if (isNilOrEmpty(version)) return obj;

  return R.assoc('version', R.inc(version), obj);
};

const incEventLocationContactVersions = (event) => {
  const { location } = event;

  const contacts = R.pathOr([], ['contacts'], location);
  const newContacts = R.map((contact) => incObjectVersion(contact), contacts);
  const newLocation = incObjectVersion(location);
  const newLocationWithContacts = R.assoc('contacts', newContacts, newLocation);
  const newEvent = R.assoc('location', newLocationWithContacts, event);

  return incObjectVersion(newEvent);
};

// helper for creating new Array from object after handling object by function
const getNewArrayFromObjectWithHandling = (handler, object) => (
  R.values(R.mapObjIndexed(handler, object))
);

// Not used
// helper for creating new object from object with same properties but boolean values
// const getNewObjectWithBoolValues = (object, value) => (
//   R.map(() => value, object)
// );

// get options from data array
const getOptionsFromDataArrayByPath = (pathToLabel, pathToValue, data = []) => R.map(
  (item) => ({
    label: R.path(pathToLabel, item),
    value: R.path(pathToValue, item),
  }),
  data,
);

const omitGuidFromObjectsInArray = (array) => R.map(R.dissoc(GC.FIELD_GUID), array);

export {
  notInList,
  renameKeys,
  reorderList,
  // indexToValue,
  // filterWithKeys,
  sortListByDate,
  incObjectVersion,
  mapWithRenameKeys,
  // toNumberObjectValues,
  pickObjectSystemFields,
  omitObjectSystemFields,
  // mapOptionsValueToGuids,
  mapNameGuidToLabelValue,
  filterAndJoinObjectFields,
  mapOmitObjectSystemFields,
  // getNewObjectWithBoolValues,
  checkPropNotEqualInObjects,
  omitGuidFromObjectsInArray,
  createLabelValueOptionObject,
  mapArrayOfObjectsToPropArray,
  prependEmptyLabelValueOption,
  getOptionsFromDataArrayByPath,
  setPropsWithValuesToArrayItems,
  incEventLocationContactVersions,
  getArrayFilteredFromArrayByProp,
  mapObjectEmptyStringFieldsToNull,
  getNewArrayFromObjectWithHandling,
  mapObjectNullFieldsToEmptyStrings,
  pickNotNilAndNotEmptyPropsFromObject,
  omitObjectChildArrayItemSystemFields,
  mapArrayObjectEmptyStringFieldsToNull,
  setStringValueInsteadObjectValueByPath,
  mapNameGuidObjectPropsToLabelValueObject,
  transformArrayOfObjectsToStringByPropName,
  mapUnitIdGuidObjectPropsToLabelValueObject,
  omitObjectChildArrayItemSystemFieldsCurried,
  mapObjectChildArrayItemEmptyStringFieldsToNull,
  mapDisplayNameGuidObjectPropsToLabelValueObject,
  mapDisplayedValueDropdownOptionGuidToLabelValue,
};
